const BANNER_SELECTOR = '[data-collection-grid-banner]';
const PRODUCT_SELECTOR = ':scope > .product-grid__item[data-product-id]';

/** Randomize an array in place using Fisher-Yates. */
function shuffle(items) {
  for (let index = items.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
  }

  return items;
}

function placeCollectionBanners(grid) {
  if (!(grid instanceof HTMLElement) || grid.dataset.bannersPositioned === 'true') return;

  const banners = shuffle(Array.from(grid.querySelectorAll(`:scope > ${BANNER_SELECTOR}`)));
  const products = Array.from(grid.querySelectorAll(PRODUCT_SELECTOR));
  if (!banners.length || products.length < 2) return;

  // Mark before moving nodes so the document observer cannot position this grid twice.
  grid.dataset.bannersPositioned = 'true';

  const productCount = products.length;
  const gridColumns = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
  grid.dataset.bannerColumnCount = gridColumns.toString();

  // A full-width banner must follow the last product in a complete row.
  // Otherwise CSS Grid leaves empty columns before the banner.
  const rowBoundaries = [];
  for (let productNumber = gridColumns; productNumber <= productCount; productNumber += gridColumns) {
    rowBoundaries.push(productNumber - 1);
  }
  if (rowBoundaries.at(-1) !== productCount - 1) rowBoundaries.push(productCount - 1);

  const positions = shuffle(rowBoundaries).slice(0, banners.length).sort((a, b) => a - b);

  banners.forEach((banner, index) => {
    const productIndex = positions[index] ?? productCount - 1;
    banner.dataset.bannerPlaced = 'true';
    products[productIndex].after(banner);
  });
}

function initializeCollectionBanners(root = document) {
  root.querySelectorAll?.('.product-grid').forEach(placeCollectionBanners);
}

initializeCollectionBanners();

// Horizon replaces the results grid after filters, sorting and pagination.
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (node.matches('.product-grid')) placeCollectionBanners(node);
      if (node.matches(BANNER_SELECTOR) && node.dataset.bannerPlaced !== 'true') {
        const grid = node.closest('.product-grid');
        if (grid) {
          delete grid.dataset.bannersPositioned;
          placeCollectionBanners(grid);
        }
      }
      initializeCollectionBanners(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll('.product-grid').forEach((grid) => {
      const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      if (columns.toString() === grid.dataset.bannerColumnCount) return;
      const banners = Array.from(grid.querySelectorAll(`:scope > ${BANNER_SELECTOR}`));
      banners.forEach((banner) => {
        delete banner.dataset.bannerPlaced;
        grid.append(banner);
      });
      delete grid.dataset.bannersPositioned;
      placeCollectionBanners(grid);
    });
  }, 120);
});

document.addEventListener('click', (event) => {
  const link = event.target.closest?.('.collection-grid-banner__link');
  if (!link) return;
  event.stopPropagation();
});
